// extracted by mini-css-extract-plugin
export default {"nav_3":"index-module_nav_3_pFdR1","navItemWp":"index-module_navItemWp_gJfI5","navItem":"index-module_navItem_lEVjT"};